module.exports = __webpack_public_path__ + "static/media/280711.e446308f.png";